import DigitalBundlesMissingConfigurationNotice from './DigitalBundlesMissingConfigurationNotice';

export default DigitalBundlesMissingConfigurationNotice;
